import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { TranslatePipe } from '@ngx-translate/core'

export type ConfirmDialogResult = { confirmed: boolean; checkboxChecked: boolean }

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [MatButton, TranslatePipe, MatDialogActions, MatDialogContent, MatDialogTitle, MatCheckboxModule, FormsModule],
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  data: {
    title?: string
    description?: string
    confirmLabel?: string
    cancelLabel?: string
    checkboxLabel?: string
    checkboxDefault?: boolean
  } = inject(MAT_DIALOG_DATA)
  dialog = inject(MatDialogRef<ConfirmDialogComponent>)

  checkboxChecked = this.data.checkboxDefault ?? false

  @HostListener('document:keydown', ['$event'])
  triggerKeys(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closeDialog(false)
    }
    if (event.key === 'Enter') {
      this.closeDialog(true)
    }
  }

  closeDialog(confirmed: boolean) {
    if (this.data.checkboxLabel) {
      this.dialog.close({ confirmed, checkboxChecked: this.checkboxChecked })
    } else {
      this.dialog.close(confirmed)
    }
  }
}
